import React, { FunctionComponent, SyntheticEvent, ReactNode } from 'react'
import { Button, Text } from '@afterpaytouch/core'

import { AssetChildComponentSpacing, MarginSize } from './types'
import { getSpacingClassName } from './helper'

interface Props extends AssetChildComponentSpacing {
  show?: boolean
  onClick?: (e: SyntheticEvent<HTMLElement>) => void
  children?: ReactNode
  disabled?: boolean
  bold?: boolean
}

export const FooterLink: FunctionComponent<Props> = ({
  show = true,
  onClick = () => {},
  disabled = false,
  children,
  bold = true,
  margin,
  marginTop = MarginSize.x4,
  marginBottom,
}) => {
  if (!show || !children) {
    return null
  }

  return (
    <div className={getSpacingClassName({ margin, marginTop, marginBottom })}>
      <Button kind='Link' onClick={onClick} testNameSpace='postcheckout-footerLink' disabled={disabled}>
        <Text size='S' bold={bold} testNameSpace='postcheckout-footerLink'>
          {children}
        </Text>
      </Button>
    </div>
  )
}
